<li
  class="fs-nav-item"
  [ngClass]="[class || '', hasChildren ? 'fs-has-child' : '', open ? 'fs-nav-open' : '']"
  mat-ripple
  [routerLinkActive]="'fs-active-item'"
  [matRippleDisabled]="noRipple || navClosed || open"
>
  <div class="fs-nav-container">
    <a
      [routerLink]="link"
      [routerLinkActive]="'fs-active'"
      [routerLinkActiveOptions]="{ exact: exact }"
      class="fs-nav-link"
      [style.padding-left.px]="linkPaddingLeft"
      (click)="onClick($event)"
      [ngClass]="{ 'fs-inactive': noActive }"
    >
      <span class="fs-nav-icon-slot" [class.fs-nav-icon-slot-empty]="!icon" aria-hidden="true">
        <ng-container *ngIf="icon">
          <ng-container *ngIf="utilsService.iconIsString(icon); else elseTemplate">
            <img src="{{ icon }}" alt="D" />
          </ng-container>
          <ng-template #elseTemplate>
            <fa-icon [icon]="$any(icon)"></fa-icon>
          </ng-template>
        </ng-container>
      </span>
      <div class="fs-nav-info">
        <label *ngIf="label" class="fs-nav-label">
          <span>{{ label }}</span>
        </label>
      </div>
    </a>
    <div
      *ngIf="hasChildren && !navClosed"
      [routerLinkActive]="'fs-active'"
      (click)="toggleOpen()"
      class="fs-nav-toggle"
      [matTooltip]="getToggleTooltip()"
      [matTooltipDisabled]="!navClosed"
      matTooltipPosition="right"
    >
      <fa-icon [icon]="open ? faMinusSquare : faPlusSquare"></fa-icon>
    </div>
  </div>
  <ng-content *ngIf="navClosed || open"></ng-content>
</li>
